import axios from 'axios';

import { tokenStorage } from './utils/tokenStorage';

// Create axios instance with base URL and timeout
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000, // 30 second timeout to prevent indefinite hanging
});

// Add a request interceptor to attach the token to API requests
instance.interceptors.request.use(
  (config) => {
    // Try to get the token from centralized storage
    const token = tokenStorage.get();
    // console.log('[Axios Interceptor] Request to:', config.url, 'Token available:', !!token);
    if (token && config.headers) {
      // Set the authorization header if token exists and headers are defined
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('[Axios Interceptor] Authorization header set');
    } else {
      // console.log('[Axios Interceptor] No token or headers available');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
